// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"608":"977f552a","649":"977f552a","685":"977f552a","986":"977f552a"}[chunkId] + ".chunk.css";
};